import classnames from 'classnames';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { isIosApp, isIosWeb } from 'utils/platform';

import CSS from './AuthButtons.module.scss';
import SocialLogin from './SocialLogin';

interface AuthButtonsProps {
  afterLogin?: () => any;
  companyName?: string;
  lastUsedProvider?: 'google' | 'facebook' | 'apple' | 'email';
  variant: 'compact' | 'large';
}

function AuthButtons({
  afterLogin,
  lastUsedProvider,
  variant,
}: AuthButtonsProps) {
  const history = useHistory();
  const searchParams = new URLSearchParams(window.location.search);
  const returnTo = searchParams.get('returnTo') || '/';
  const onLoginResult =
    (setState: (any) => any) =>
    ({
      error,
      success,
      redirectUrl,
    }: {
      error?: any;
      success: boolean;
      redirectUrl?: string;
    }) => {
      if (!success) {
        console.error(`Login failed: ${error}`);
        setState({ error: `Login failed: ${error}`, loading: false });
        return;
      }

      setState({ error: null, loading: false });

      if (redirectUrl) {
        const startsWithSlash = redirectUrl.startsWith('/');
        if (startsWithSlash) {
          history.push(redirectUrl);
        } else {
          window.location.href = redirectUrl;
          return;
        }
      }
    };
  const AppleAuthButton = (
    <SocialLogin
      provider="apple"
      afterLogin={afterLogin}
      callbackUrl={returnTo}
      onLoginResult={onLoginResult}
      isLastUsed={lastUsedProvider === 'apple'}
      variant={variant}
    />
  );
  return (
    <div
      className={classnames(CSS.AuthButtons, {
        [CSS.AuthButtonsLarge]: variant === 'large',
      })}
    >
      <SocialLogin
        provider="facebook"
        afterLogin={afterLogin}
        callbackUrl={returnTo}
        onLoginResult={onLoginResult}
        isLastUsed={lastUsedProvider === 'facebook'}
        variant={variant}
      />
      {!isIosApp() && !isIosWeb() && AppleAuthButton}
      <SocialLogin
        provider="google"
        afterLogin={afterLogin}
        callbackUrl={returnTo}
        onLoginResult={onLoginResult}
        isLastUsed={lastUsedProvider === 'google'}
        variant={variant}
      />
      {(isIosApp() || isIosWeb()) && AppleAuthButton}
    </div>
  );
}

export default AuthButtons;
